import { useState } from 'react';
import { ObjectI, QueryI } from '../../../libs/interfaces';



export const useAutocompleteInput = (
  clientesQuery:QueryI, 
  ) => {
    
    const [ forms, setForms ] = useState({
        value:'',
        id:0,
      });

 

    const handleFormsAutocomplete = (event: any, newValue: string | null)=>{ 
        let id:number =0;

        if(event.target && event.target.value)
          id = clientesQuery.data.data.find((el:ObjectI)=>el.name === event.target.value)!.id;
        
        setForms({...forms, 
            value:event.target?.value ?? "",
            id:id,
        })
    }

  
  return {
    value:forms.value,
    id:forms.id,
    handleFormsAutocomplete
  }
}
